import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { motion } from "framer-motion";

const formatTime = (iso) => {
    const d = new Date(iso);
    return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};

const scoreColor = (n) => (n >= 80 ? "text-sage" : n >= 60 ? "text-terracotta" : n >= 40 ? "text-amber-700" : "text-red-700");

export default function SessionCard({ session }) {
    const a = session.analysis || {};
    const score = a.overall_score ?? 0;
    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
        >
            <Link
                to={`/session/${session.id}`}
                className="group block rounded-3xl border border-stone-200/80 dark:border-stone-800 bg-white/70 dark:bg-[#242322]/70 backdrop-blur-md p-5 sm:p-6 hover:shadow-[0_8px_30px_rgba(44,43,42,0.08)] transition-all"
                data-testid={`session-card-${session.id}`}
            >
                <div className="flex items-start justify-between gap-3">
                    <div className="flex items-center gap-2 text-[10px] tracking-[0.2em] uppercase font-bold text-stone-400">
                        <span>{session.prompt_category}</span>
                        <span className="text-stone-300">·</span>
                        <span>{formatTime(session.created_at)}</span>
                        <span className="text-stone-300">·</span>
                        <span>{Math.floor((session.duration_sec || 0) / 60)}:{((session.duration_sec || 0) % 60).toString().padStart(2, "0")}</span>
                    </div>
                    <ChevronRight size={18} strokeWidth={1.5} className="text-stone-300 group-hover:text-terracotta transition-colors" />
                </div>

                <div className="mt-2 flex items-start justify-between gap-4">
                    <h3 className="font-serif text-2xl sm:text-3xl font-medium tracking-tight line-clamp-2" data-testid="session-card-title">
                        {session.prompt_title}
                    </h3>
                    <div className={`shrink-0 font-serif text-5xl font-light ${scoreColor(score)}`} data-testid="session-card-score">
                        {score}
                    </div>
                </div>

                {a.one_line_takeaway && (
                    <p className="mt-3 text-sm text-stone-600 dark:text-stone-400 line-clamp-2 leading-relaxed italic">
                        “{a.one_line_takeaway}”
                    </p>
                )}
            </Link>
        </motion.div>
    );
}
